module.exports = __webpack_public_path__ + "static/media/img46.c6e6c2c1.jpg";